/**
 * @fileoverview Line-item money maths, shared by the till app and QuickStock Cloud.
 *
 * CANONICAL COPY. This module was extracted from backend/src/utils/posCalculator.js.
 * Both the till and the cloud read it, so the two can never disagree about what a
 * line is worth. Change it only with a matching test, and remember that any change
 * alters figures on printed receipts as well as on the dashboard.
 *
 * All arithmetic goes through Decimal. Sale figures are compared against Z-readings
 * and VAT returns, so binary floating point is not acceptable here.
 */

const Decimal = require('decimal.js');

/**
 * Returns the effective unit price based on trnx type.
 * @param {Object} product - Should have properties salePrice and returnPrice.
 * @param {string} trnxType - 'sale' or 'sale_return'.
 * @returns {number}
 */
function getEffectiveUnitPrice(product, trnxType = 'sale') {
  return trnxType === 'sale' ? product.salePrice : product.returnPrice;
}

/**
 * Calculates the aggregated (line item) totals for a product.
 * @param {Object} product - Should have salePrice/returnPrice, discount, and quantity.
 * @param {string} trnxType - 'sale' or 'sale_return'
 * @returns {Object} - { aggregatedSale, aggregatedDiscount, aggregatedFinal }
 */
function calculateAggregatedLineTotals(product, trnxType = 'sale') {
  const dUnitPrice = new Decimal(getEffectiveUnitPrice(product, trnxType));
  const dDiscount = new Decimal(product.discount);
  const dQuantity = new Decimal(product.quantity);

  const aggregatedSale = dUnitPrice.mul(dQuantity);
  const aggregatedDiscount = dDiscount.mul(dQuantity);
  const aggregatedFinal = aggregatedSale.sub(aggregatedDiscount);

  return {
    aggregatedSale,
    aggregatedDiscount,
    aggregatedFinal,
  };
}

module.exports = {
  getEffectiveUnitPrice,
  calculateAggregatedLineTotals
};
